// City landing pages for local SEO across the Lehigh Valley.
export const CITIES = {
  allentown: {
    name: "Allentown",
    county: "Lehigh County",
    metaTitle: "Home Remodeling in Allentown, PA | Kitchens, Baths & Additions | Apex Home Pro",
    metaDescription:
      "Trusted home remodeling contractor in Allentown, PA. Kitchen & bathroom remodels, additions, decks, flooring and concrete. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "As the largest city in the Lehigh Valley, Allentown is full of character homes — from West End Tudors and Victorians to newer builds in South Allentown. Apex Home Pro Inc remodels them all, matching craftsmanship to the age and style of your house.",
      "Whether you're updating a dated kitchen in the West End, finishing a basement near Cedar Beach, or adding space to a growing family home, we bring one accountable crew and honest pricing to every Allentown project.",
    ],
    areas: ["West End", "South Side", "East Side", "Center City", "Midway Manor"],
    nearby: ["bethlehem", "whitehall", "emmaus"],
  },
  bethlehem: {
    name: "Bethlehem",
    county: "Lehigh & Northampton Counties",
    metaTitle: "Home Remodeling in Bethlehem, PA | Kitchens, Baths & Decks | Apex Home Pro",
    metaDescription:
      "Home remodeling contractor serving Bethlehem, PA. Kitchen & bath renovations, decks, framing, flooring and more. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Bethlehem blends historic charm with modern living, and its homes deserve remodeling that respects both. Apex Home Pro Inc works throughout the city — from the tree-lined streets of the Historic District to newer neighborhoods on the west and north sides.",
      "We handle everything from careful bathroom and kitchen renovations in older homes to decks and additions that extend your living space, all built to code and finished with care.",
    ],
    areas: ["Historic District", "West Bethlehem", "North Side", "Saucon Valley edge", "Lehigh University area"],
    nearby: ["allentown", "easton", "nazareth"],
  },
  easton: {
    name: "Easton",
    county: "Northampton County",
    metaTitle: "Home Remodeling in Easton, PA | Renovations & Additions | Apex Home Pro",
    metaDescription:
      "Remodeling contractor serving Easton, PA. Kitchens, bathrooms, decks, flooring, framing and concrete. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "At the eastern edge of the Lehigh Valley where the Delaware and Lehigh rivers meet, Easton is known for its historic rowhomes and revitalized downtown. Apex Home Pro Inc renovates these classic homes with respect for their character and the durability modern living demands.",
      "From tight downtown rowhome kitchens to full renovations in College Hill, we bring precise craftsmanship and clear communication to every Easton project.",
    ],
    areas: ["Downtown", "College Hill", "West Ward", "South Side"],
    nearby: ["bethlehem", "nazareth", "wescosville"],
  },
  emmaus: {
    name: "Emmaus",
    county: "Lehigh County",
    metaTitle: "Home Remodeling in Emmaus, PA | Kitchens, Baths & Decks | Apex Home Pro",
    metaDescription:
      "Home remodeling in Emmaus, PA. Kitchen & bathroom remodels, decks, flooring and additions. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1613544723371-23b514a78c85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Emmaus is a close-knit borough with well-kept older homes and a strong sense of community. Apex Home Pro Inc helps homeowners here update kitchens and baths, build decks for the backyard, and finish spaces that make these homes work for today's families.",
      "We're just up the road, so Emmaus projects get quick, attentive service from a crew that knows the area.",
    ],
    areas: ["Downtown Emmaus", "Vera Cruz", "Wescosville edge", "Macungie edge"],
    nearby: ["allentown", "macungie", "wescosville"],
  },
  macungie: {
    name: "Macungie",
    county: "Lehigh County",
    metaTitle: "Home Remodeling in Macungie, PA | Renovations & Additions | Apex Home Pro",
    metaDescription:
      "Remodeling contractor serving Macungie, PA. Kitchens, bathrooms, decks, concrete and additions. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Macungie mixes historic borough homes with newer developments in the surrounding townships. Apex Home Pro Inc remodels both — refreshing older kitchens and baths and adding decks, concrete patios and finished spaces to newer homes.",
      "As a local Lehigh Valley company, we give Macungie homeowners the responsiveness and accountability the big-box remodelers can't.",
    ],
    areas: ["Borough of Macungie", "Lower Macungie", "Alburtis edge"],
    nearby: ["emmaus", "allentown", "wescosville"],
  },
  whitehall: {
    name: "Whitehall",
    county: "Lehigh County",
    metaTitle: "Home Remodeling in Whitehall, PA | Kitchens, Baths & Decks | Apex Home Pro",
    metaDescription:
      "Home remodeling in Whitehall Township, PA. Kitchen & bath remodels, decks, flooring and concrete. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1521783593447-5702b9bfd267?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Whitehall Township's mix of mid-century and newer homes gives homeowners plenty of room to modernize. Apex Home Pro Inc updates kitchens and bathrooms, replaces flooring, and builds decks and patios for families across Whitehall and Egypt.",
      "We keep Whitehall projects on schedule and on budget, with the same crew from first estimate to final walkthrough.",
    ],
    areas: ["Whitehall", "Egypt", "Cementon", "Fullerton edge"],
    nearby: ["allentown", "bethlehem", "nazareth"],
  },
  nazareth: {
    name: "Nazareth",
    county: "Northampton County",
    metaTitle: "Home Remodeling in Nazareth, PA | Renovations & Additions | Apex Home Pro",
    metaDescription:
      "Remodeling contractor serving Nazareth, PA. Kitchens, bathrooms, framing, decks and concrete. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Nazareth's historic borough and surrounding countryside are home to everything from centuries-old houses to modern builds. Apex Home Pro Inc brings the framing and structural expertise these projects often need, along with beautiful kitchen, bath and finish work.",
      "From additions on rural properties to careful renovations of older homes, Nazareth homeowners get craftsmanship built to last.",
    ],
    areas: ["Borough of Nazareth", "Upper Nazareth", "Bushkill edge", "Tatamy edge"],
    nearby: ["bethlehem", "easton", "wescosville"],
  },
  wescosville: {
    name: "Wescosville",
    county: "Lehigh County",
    metaTitle: "Home Remodeling in Wescosville, PA | Local Contractor | Apex Home Pro",
    metaDescription:
      "Your local home remodeling contractor in Wescosville, PA. Kitchens, baths, decks, flooring, concrete and additions. Free estimates from Apex Home Pro Inc.",
    hero: "https://images.unsplash.com/photo-1609347744403-2306e8a9ae27?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro: [
      "Wescosville is our home base — Apex Home Pro Inc is located right on Broad Street. That means the fastest response times and the most familiar local knowledge for homeowners here.",
      "From quick kitchen and bath updates to decks, concrete and full renovations, your neighbors at Apex are just minutes away.",
    ],
    areas: ["Wescosville", "Lower Macungie", "Dorneyville edge", "Trexlertown edge"],
    nearby: ["allentown", "emmaus", "macungie"],
  },
};

export const CITY_SLUGS = Object.keys(CITIES);
